import { motion, useAnimation } from 'framer-motion'
import SVGJSContainer, { pathDrawDelete } from '../../../utils/SVGJSContainer'
import NumberAnimate from '../../NumberAnimate'

function Immeubles5() {
	const controls = useAnimation()

	return (
		<SVGJSContainer controls={controls}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="695.842"
				height="700"
				viewBox="0 0 695.842 700"
			>
				<defs>
					<linearGradient
						id="linear-gradientImmeubles5"
						x1="1"
						x2="0.364"
						y2="0.617"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0" stopColor="#d5eaee"></stop>
						<stop offset="1" stopColor="#7eaab8"></stop>
					</linearGradient>
				</defs>
				<g data-name="Groupe 2564" transform="translate(-1045.445 -3321.227)">
					<motion.g
						data-name="Groupe 2530"
						transform="translate(928.741 181.5)"
						strokeWidth="20"
						stroke="#fff"
						variants={pathDrawDelete}
						initial="hidden"
						animate={controls}
					>
						<path
							fill="#d5eaee"
							d="M0 0H695.84V695.84H0z"
							data-name="Rectangle 2285"
							transform="translate(116.706 3139.727)"
						></path>
						<path
							fill="url(#linear-gradientImmeubles5)"
							d="M-11528.794-1158.183v248.83h227.368l468.472-468.476V-1605.2h-248.732z"
							data-name="Tracé 30520"
							transform="translate(11645.498 4749.08)"
						></path>
					</motion.g>
					<text
						data-name="1 531"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="150"
						fontWeight="700"
						letterSpacing="-.05em"
						transform="translate(1392.742 3737.035)"
					>
						<tspan x="-176.367" y="0">
							<NumberAnimate tspan nb={1531} duration={2.5} delay={1} />
						</tspan>
					</text>
				</g>
			</svg>
		</SVGJSContainer>
	)
}

export default Immeubles5
